const LOCAL_SENTRY_ENVIRONMENTS = new Set(["local", "test", "testing"]);

export const resolveSentryEnvironment = (
  configuredEnvironment: string | undefined,
  mode: string,
): string => configuredEnvironment ?? mode;

export const shouldInitializeSentry = ({
  dsn,
  environment,
  isProductionBuild,
}: {
  readonly dsn: string | undefined;
  readonly environment: string;
  readonly isProductionBuild: boolean;
}): boolean =>
  isProductionBuild &&
  dsn !== undefined &&
  dsn !== "" &&
  !LOCAL_SENTRY_ENVIRONMENTS.has(environment.toLowerCase());
